import useSWR from 'swr';
import { SF_API_BASE } from '@/constants/env';
import { Category, Error } from '@/interfaces';
import { UseRequestOpts } from './useRequest.d';

const useRequest = (
  categoryType: string,
  slug: string,
  qs = '',
  fetcherWithOptions: (...args: any) => any,
  opts?: UseRequestOpts
): {
  data: Category | Error;
  error: unknown;
  mutate: unknown;
  isLoading: boolean;
} => {
  const initialData = opts?.initialData;

  const { data, error, mutate } = useSWR(
    `${SF_API_BASE}/catalog_categories/${categoryType}/${slug}?${qs}`,
    fetcherWithOptions,
    { ...(initialData ? initialData : {}) }
  );
  return {
    data,
    error,
    mutate,
    isLoading: !error && !data,
  };
};

export default useRequest;
